import { toRefs, computed } from 'vue';
import tinycolor from 'tinycolor2';
import { useLink } from '../component-lib.esm6.js';
import { LINK_PROPS } from '../component-lib.esm2.js';
import { useTheme } from '../../compositions/component-lib.esm3.js';

//
var script = {
  props: LINK_PROPS,
  setup(props, context) {
    const {
      link
    } = toRefs(props);
    const theme = useTheme();
    const {
      id,
      variant
    } = useLink(props, context);
    const classes = computed(() => {
      return {
        [`site__divider--${link.value.label}`]: link.value.label,
        [`site__divider--${variant.value}`]: variant.value
      };
    });
    const styles = computed(() => {
      const color = theme.value.profile.dividerColor;
      const otherStyles = {};
      if (variant.value === 'glow') {
        otherStyles['--c-divider-glow'] = tinycolor(color).triad()[1];
      }
      return {
        ...otherStyles,
        'background-image': variant.value === 'zigzag' ? `url('data:image/svg+xml;utf-8,<svg xmlns="http://www.w3.org/2000/svg" width="9" height="6" xml:space="preserve" fill="${encodeURIComponent(color)}"><path d="M4.5 4.5 0 0v1.208l4.5 4.5 4.5-4.5V0z"/></svg>')` : null
      };
    });
    return {
      id,
      classes,
      styles
    };
  }
};
export { script as default };